import { render, staticRenderFns } from "./PhotosListing.vue?vue&type=template&id=5552c73d"
import script from "./PhotosListing.vue?vue&type=script&lang=js"
export * from "./PhotosListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports